import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { any } from 'prop-types';
import { WalletInfoState } from '../../../../types/types';

const initialState:WalletInfoState = 
{
  has_key: false, account_key: null,
  account_private_key: null, device_key: null,
  device_private_key: null, mnemonic: null,
  info: any
}

const walletInfo = createSlice({
  name: 'walletInfo',
  initialState,
  reducers: {
   
    setWalletInfo: (state,action:PayloadAction<WalletInfoState>) => {

        state = {...action.payload}
        return (state)
      
    },
  },
 
});

// Reducer
export default walletInfo.reducer;

// Actions
export const {setWalletInfo} = walletInfo.actions;